import {
  useMemo,
  useState,
  useEffect,
} from 'react';

import {
  User,
  Namespace,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import config from 'web-config';

import {
  getOnboardSteps,
} from '../onboard_data';

import Step from './Step';
import * as S from './styled';

type Props = {
  profile: User,
  percentage: number,
  namespace: Namespace,
  onGoal: { (id: string): void },
};

const Onboarding = ({
  profile,
  percentage,
  namespace,
  onGoal,
}: Props) => {
  const userSteps = profile.user_settings.tutorial_steps;
  const {
    steps,
    current,
    stepKeys,
  } = useMemo(() => getOnboardSteps(namespace.symbol, profile), [userSteps]);

  const [goal, setActive] = useState<any>(
    steps[current],
  );

  useEffect(() => {
    const index = stepKeys.findIndex(s => s.name === goal.id);
    if (userSteps.includes(goal.id) && stepKeys[index + 1]?.name) {
      setActive(
        steps[stepKeys[index + 1].name],
      );
    }
  }, [userSteps.length]);

  const renderCurrentButton = () => {
    const defaultButton = (
      <S.GoalButton
        onClick={() => {
          onGoal(goal.id);
        }}
      >
        {goal.button}
      </S.GoalButton>
    );

    return {
      perform_workout: (
        <Flex spacing={20}>
          <S.GoalButton
            as="a"
            href={config.mobile.app_store_url}
            target="_blank"
          >
            App Store
          </S.GoalButton>
          <S.GoalButton
            as="a"
            href={config.mobile.google_play_url}
            target="_blank"
          >
            Google Play
          </S.GoalButton>
        </Flex>
      ),
      got_questions: (
        <S.GoalButton
          onClick={() => {
            onGoal(goal.id);
          }}
        >
          {goal.button}
        </S.GoalButton>
      ),
    }[goal.id] || defaultButton;
  };

  return (
    <S.Onboarding>
      <Flex
        width="100%"
        column
        spacing={30}
      >
        <S.ProgressBar>
          <S.Progress
            style={{ width: `${percentage}%` }}
          />
        </S.ProgressBar>
        <Flex
          column
          spacing={10}
        >
          <Text
            size="18px"
            weight="700"
            color="#757575"
          >
            {goal.title(profile.user_profile)}
          </Text>
          <Text
            size="17px"
            color="#757575"
            dangerouslySetInnerHTML={{ __html: goal.description }}
          />
        </Flex>
      </Flex>
      {goal.article && (
        <S.Article
          target="_blank"
          href={goal.link}
          rel="noopener noreferrer"
        >
          {goal.article}
        </S.Article>
      )}
      <Flex
        width="100%"
        align="center"
        justify="space-between"
      >
        {renderCurrentButton()}
        <Flex
          align="center"
          spacing={15}
        >
          {stepKeys.map((item, index) => (
            <Step
              id={item.name}
              key={item.name}
              index={namespace.symbol === 'ideafit' ? undefined : index + 1}
              tooltip={goal.tooltip}
              isActive={item.name === goal.id}
              isCompleted={item.isCompleted}
              onClick={() => {
                setActive(
                  steps[item.name],
                );
              }}
            />
          ))}
        </Flex>
      </Flex>
    </S.Onboarding>
  );
};

export default Onboarding;
